import { ArrowUpOutlined } from '@ant-design/icons';
import { Card, Statistic } from 'antd';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import css from './Home.module.css';

function Stats(props) {
    let [stats, setStats] = useState({
        books: 0,
        videos: 0,
        musics: 0
    })

    useEffect(() => {
        axios.get('/stats').then(res => {
            if (res.status === 200) {
                setStats(res.data)
            }
        })
    }, [])
    return (
        <div style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr 1fr',
            gap: '20px',
        }}>
            <Card className={css.statcard} style={{backgroundColor: '#81b29a'}}>
                <Statistic title={<span style={{ fontSize: '18px', color: '#fff', fontWeight: 'bold' }}>Kitoblar</span>}
                    value={stats.books}
                    precision={0}
                    valueStyle={{ color: '#f4f1de' }}
                    prefix={<ArrowUpOutlined />}
                    suffix="ta"
                />
            </Card>
            <Card className={css.statcard} style={{backgroundColor: '#3d405b'}}>
                <Statistic title={<span style={{ fontSize: '18px', color: '#fff', fontWeight: 'bold' }}>Videolar</span>}
                    value={stats.videos}
                    precision={0}
                    valueStyle={{ color: '#f4f1de' }}
                    prefix={<ArrowUpOutlined />}
                    suffix="ta"
                />
            </Card>
            <Card className={css.statcard} style={{backgroundColor: '#e07a5f'}}>
                <Statistic title={<span style={{ fontSize: '18px', color: '#fff', fontWeight: 'bold' }}>Audiolar</span>}
                    value={stats.musics}
                    precision={0}
                    valueStyle={{ color: '#f4f1de' }}
                    prefix={<ArrowUpOutlined />}
                    suffix="ta"
                />
            </Card>

        </div>
    );
}

export default Stats;